import { render, staticRenderFns } from "./HomeDark.vue?vue&type=template&id=af9a70ce&"
import script from "./HomeDark.vue?vue&type=script&lang=js&"
export * from "./HomeDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports